import * as apiGetStartingWith from 'api/ingredient/GetIngredientStartingWithV1';
import * as apiPostSearch from 'api/ingredient/PostIngredientSearchV1';
import { ISelectItem } from 'interfaces/ISelectItem';
import * as IngredientList from 'types/Ingredient/Search/IngredientList';
import * as RangeWithIdList from 'types/Ingredient/Search/RangeWithIdList';
import * as Search from 'types/Ingredient/Search/Search';

export type Type = {
	data: IngredientList.Type;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	pageIndex: number;
	pageSize: number;
	totalCount: number;
	totalPages: number;
	ranges: RangeWithIdList.Type;
};

export function create(): Type {
	return {
		data: IngredientList.create(),
		hasNextPage: false,
		hasPreviousPage: false,
		pageIndex: 0,
		pageSize: 0,
		ranges: RangeWithIdList.create(),
		totalCount: 0,
		totalPages: 0,
	};
}

export async function getFromApi(search: Search.Type): Promise<Type> {
	const response = await apiPostSearch.callApi(Search.mapToApi(search));
	const responseData = response.toNullable();
	if (responseData) return mapFromApi(responseData);
	return create();
}

export async function getFromApiSW(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<ISelectItem[]> {
	const response = await apiGetStartingWith.callApi(searchTerm, showOnlyDeleted);
	const responseData = response.toNullable();
	if (responseData) return mapToISelectItem(responseData);
	return [];
}

export function mapFromApi(input: apiPostSearch.ResponseData): Type {
	return {
		...input,
		ranges: RangeWithIdList.mapFromApi(input),
		data: IngredientList.mapFromApi(input.data),
	};
}

export function mapToISelectItem(input: apiGetStartingWith.ResponseIngredient[]): ISelectItem[] {
	return input.map<ISelectItem>((x: apiGetStartingWith.ResponseIngredient) => ({
		id: x.id,
		name: x.description,
	}));
}
